// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AlphabetNavigation, {
    AlphabetNavigationStyles,
    LetterDetails,
} from "@conklin/Overrides/Widgets/Brand/AlphabetNavigation";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import React, { FC, useState } from "react";

interface Props {
    letterDetails: LetterDetails[];
    extendedStyles?: BrandAlphabetNavigationStyles;
    onBrandLetterClick?: (letter: string) => void;
    // XNG-Changes
    handleSearchFilterBrands?: (e: string) => void;
    searchFilterBrands?: string;
    selectedLetter?: string;
}

export interface BrandAlphabetNavigationStyles {
    alphabetNavigation?: AlphabetNavigationStyles;
}

export const brandAlphabetNavigationStyles: BrandAlphabetNavigationStyles = {};

const BrandAlphabetNavigation: FC<Props> = ({
    letterDetails,
    onBrandLetterClick,
    extendedStyles,
    // XNG-Changes
    handleSearchFilterBrands,
    searchFilterBrands,
    selectedLetter,
}) => {
    const [styles] = useState(() => mergeToNew(brandAlphabetNavigationStyles, extendedStyles));

    return (
        <AlphabetNavigation
            alphabet={letterDetails}
            extendedStyles={styles.alphabetNavigation}
            onLetterClick={onBrandLetterClick}
            handleSearchFilterBrands={handleSearchFilterBrands}
            searchFilterBrands={searchFilterBrands}
            selectedLetter={selectedLetter}
        />
    );
};

export default BrandAlphabetNavigation;
